import React, { useEffect, useState } from 'react';
import { getMyProperties, getPropertyById } from '../../../api/services/propertyService';
import { getBookingIdFromNotification } from '../../shared/Notifications/notificationUtils';
import { filterPropertiesByScope } from '../../../utils/propertyScope';
import AirbnbBookingsView from './AirbnbBookings/AirbnbBookingsView';

const Bookings = ({ onNavigate, navigationState = {} }) => {
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [bookingNav, setBookingNav] = useState(null);

  useEffect(() => {
    const hasIntent =
      navigationState?.bookingId ||
      navigationState?.bookingResolveHint ||
      navigationState?.focusBookingOnly;

    if (!hasIntent) return;

    const idFromNotification = navigationState.notification
      ? getBookingIdFromNotification(navigationState.notification)
      : null;
    const bookingId = navigationState.bookingId || idFromNotification || null;

    setBookingNav({
      bookingId,
      focusBookingOnly: Boolean(navigationState.focusBookingOnly),
      openPaymentEvidence: Boolean(navigationState.openPaymentEvidence),
      bookingResolveHint: bookingId ? null : navigationState.bookingResolveHint || null,
    });
  }, [
    navigationState?.bookingId,
    navigationState?.notification,
    navigationState?.bookingResolveHint,
    navigationState?.focusBookingOnly,
    navigationState?.openPaymentEvidence,
  ]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await getMyProperties({
          page: 0,
          size: 100,
          search: '',
          dashboardScope: 'BNB',
        });
        const content = res?.data?.content || [];

        const enrichedProperties = await Promise.all(
          content.map(async (property) => {
            if (!property?.id) return property;
            try {
              const detailRes = await getPropertyById(property.id, true, { dashboardScope: 'BNB' });
              if (detailRes?.status === 'success' && detailRes?.data) {
                return { ...property, ...detailRes.data };
              }
            } catch (e) {
              // ignore
            }
            return property;
          })
        );

        const scopedProperties = filterPropertiesByScope(enrichedProperties, 'bnb', {
          includeUnscoped: true,
          inferFromUnits: true,
        });

        const list = (Array.isArray(scopedProperties) ? scopedProperties : [])
          .map((p) => ({
            id: p.id,
            name: p.name || 'Property',
            units: p.units || [],
          }))
          .filter((p) => p.id);
        if (!cancelled) setProperties(list);
      } catch (e) {
        console.error(e);
        if (!cancelled) setProperties([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const clearBookingNav = () => setBookingNav(null);

  return (
    <AirbnbBookingsView
      properties={properties}
      loadingProperties={loading}
      pageTitle="Airbnb Bookings"
      emptyPropertiesMessage="Add an Airbnb property under Manage Rentals to see bookings here."
      onNavigate={onNavigate}
      highlightBookingId={bookingNav?.bookingId}
      focusBookingOnly={bookingNav?.focusBookingOnly}
      openPaymentEvidence={bookingNav?.openPaymentEvidence}
      bookingResolveHint={bookingNav?.bookingResolveHint}
      onFocusExit={clearBookingNav}
    />
  );
};

export default Bookings;
